import { muiStyles } from 'utils/design';

export const useStyles = muiStyles((theme) => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
  },
}));
